// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bbt_a bhu_i bhu_q bhu_j"};